/* global HTMLElement */

class MainNavigation extends HTMLElement {
  constructor() {
    super();
    this.links = [];
    this.panels = [];
    this.secondaryLinks = [];
    this.onLinkClick = this.onLinkClick.bind(this);
    this.onSecondaryLinkClick = this.onSecondaryLinkClick.bind(this);
  }

  connectedCallback() {
    this.links = [...this.querySelectorAll("[data-main-navigation-link]")];
    this.panels = [...this.querySelectorAll("[data-main-navigation-panel]")];
    this.secondaryLinks = [
      ...this.querySelectorAll(".main-navigation__secondary-link"),
    ];

    for (const link of this.links) {
      link.addEventListener("click", this.onLinkClick);
    }
    for (const link of this.secondaryLinks) {
      link.addEventListener("click", this.onSecondaryLinkClick);
    }
    this.classList.toggle(
      "main-navigation--panel-open",
      this.panels.some((panel) => !panel.hidden),
    );
  }

  disconnectedCallback() {
    for (const link of this.links) {
      link.removeEventListener("click", this.onLinkClick);
    }
    for (const link of this.secondaryLinks) {
      link.removeEventListener("click", this.onSecondaryLinkClick);
    }
  }

  onLinkClick(event) {
    const link = event.currentTarget;
    const panel = this.getPanel(link.dataset.mainNavigationLink);

    if (!panel?.querySelector(".main-navigation__secondary-link")) return;

    event.preventDefault();

    if (
      link.classList.contains("main-navigation__link--active") &&
      !panel.hidden
    ) {
      this.close();
      return;
    }

    this.select(link, panel);
  }

  onSecondaryLinkClick(event) {
    if (
      event.defaultPrevented ||
      event.button !== 0 ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey ||
      event.currentTarget.target === "_blank"
    ) {
      return;
    }

    this.close();
  }

  getPanel(index) {
    return this.panels.find(
      (panel) => panel.dataset.mainNavigationPanel === index,
    );
  }

  select(activeLink, activePanel) {
    this.classList.add("main-navigation--panel-open");

    for (const link of this.links) {
      const isActive = link === activeLink;
      link.classList.toggle("main-navigation__link--active", isActive);
      link.setAttribute("aria-expanded", String(isActive));
    }

    for (const panel of this.panels) {
      panel.hidden = panel !== activePanel;
      for (const link of panel.querySelectorAll(
        ".main-navigation__secondary-link--active",
      )) {
        if (!link.hasAttribute("aria-current")) {
          link.classList.remove("main-navigation__secondary-link--active");
        }
      }
    }

    const activeChild = activePanel.querySelector(
      ".main-navigation__secondary-link--active",
    );
    if (!activeChild) {
      activePanel
        .querySelector(".main-navigation__secondary-link")
        ?.classList.add("main-navigation__secondary-link--active");
    }
  }

  close() {
    this.classList.remove("main-navigation--panel-open");

    for (const link of this.links) {
      link.classList.remove("main-navigation__link--active");
      link.setAttribute("aria-expanded", "false");
    }

    for (const panel of this.panels) {
      panel.hidden = true;
    }
  }
}

if (!globalThis.customElements.get("main-navigation")) {
  globalThis.customElements.define("main-navigation", MainNavigation);
}
